import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { RecordCommentComponent } from './record-comment.component';

@NgModule({
  declarations: [
  RecordCommentComponent
],
  imports: [
    CommonModule,
    TranslateModule,
    FuseSharedModule
  ],
  entryComponents: [
    
  ],
  exports: [
    RecordCommentComponent
  ]
})
export class RecordCommentModule { }
